(() => {
  const stylesheets = new Map();
  const scripts = new Map();

  function normalized(url) {
    return new URL(url, document.baseURI).href;
  }

  function loadStylesheet(url) {
    const key = normalized(url);
    if (stylesheets.has(key)) return;
    const existing = Array.from(document.querySelectorAll('link[rel="stylesheet"]'))
      .some(link => link.href === key);
    stylesheets.set(key, true);
    if (existing) return;
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = key;
    link.onerror = () => { stylesheets.delete(key); link.remove(); };
    document.head.appendChild(link);
  }

  function loadScript(url) {
    const key = normalized(url);
    if (scripts.has(key)) return scripts.get(key);
    const existing = Array.from(document.querySelectorAll('script[src]'))
      .some(script => script.src === key);
    if (existing) return Promise.resolve();
    const promise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = key;
      script.async = false;
      script.onload = resolve;
      script.onerror = () => {
        scripts.delete(key);
        script.remove();
        reject(new Error('Unable to load theme resource'));
      };
      document.head.appendChild(script);
    });
    scripts.set(key, promise);
    return promise;
  }

  function loadResources(element) {
    (element.dataset.stylesheets || '').split('|').filter(Boolean).forEach(loadStylesheet);
    return Promise.all((element.dataset.scripts || '').split('|').filter(Boolean).map(loadScript));
  }

  if (!customElements.get('theme-resources')) {
    customElements.define('theme-resources', class extends HTMLElement {
      connectedCallback() {
        loadResources(this).catch(error => console.warn(error));
      }
    });
  }

  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const opener = event.target.closest('modal-opener');
    const selector = opener && opener.getAttribute('data-modal');
    if (!selector || !selector.startsWith('#QuickAdd-')) return;
    const modal = document.getElementById(selector.slice(1));
    if (!modal || typeof modal.show === 'function') return;
    const resources = opener.closest('.shopify-section')?.querySelector('theme-resources[data-scripts]');
    const button = opener.querySelector('button');
    if (!resources || !button) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (button.getAttribute('aria-busy') === 'true') return;
    button.setAttribute('aria-busy', 'true');
    button.classList.add('loading');
    button.querySelector('.loading-overlay__spinner')?.classList.remove('hidden');
    loadResources(resources).then(() => {
      button.removeAttribute('aria-busy');
      if (typeof modal.show === 'function' && modal.isConnected) modal.show(button);
      else {
        button.classList.remove('loading');
        button.querySelector('.loading-overlay__spinner')?.classList.add('hidden');
      }
    }).catch(error => {
      button.removeAttribute('aria-busy');
      button.classList.remove('loading');
      button.querySelector('.loading-overlay__spinner')?.classList.add('hidden');
      console.warn(error);
    });
  }, true);
})();
